import { useAppSelector } from '../../store/types'
import { getSecurityExportData } from '../../store/securities/selectors'
import Loading from '../Loading/Loading'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faExclamationTriangle } from '@awesome.me/kit-5de77b2c02/icons/classic/solid'
import ExportButton from './ExportButton'
import { toast } from 'react-toastify'

import styles from './exportStyles.module.css'
import useGridData from '../../helpers/hooks/useGridData'
import { hasValueInFilter } from '../../store/filter/helpers'
import dayjs from 'dayjs'
import { compileCsvData } from '../../store/securities/helpers'

type GridDataResult = ReturnType<typeof useGridData>
const gridDataToFileNamePart = ({
  gridDefinition,
  watchlist
}: GridDataResult) => {
  const wrapResult = (result: string) => {
    // Remove all invalid filename characters: / \ : * ? " < > |
    return `${result.replace(/[\/\\:*?"<>|]/g, '-')} `
  }
  if (watchlist?.name) {
    return wrapResult('Watchlist ' + watchlist?.name)
  }
  if (!gridDefinition) {
    return ''
  }
  if (gridDefinition.showLive) {
    return wrapResult('Live')
  }
  if (gridDefinition.queryFilter) {
    return wrapResult(gridDefinition.queryFilter)
  }
  if (
    gridDefinition.useAdvancedFilter ||
    gridDefinition.filter.securitiesAndTickers.length ||
    hasValueInFilter(gridDefinition.filter)
  ) {
    return wrapResult('filtered')
  }
  return ''
}

const ExportToastContent = () => {
  const { callState, securities, gridIndex, includeMakerName } = useAppSelector(
    getSecurityExportData
  )
  const gridData = useGridData(gridIndex ?? -1)
  if (callState.error) {
    return (
      <div>
        <FontAwesomeIcon icon={faExclamationTriangle} />
        Error processing download.
      </div>
    )
  }

  if (securities?.length) {
    const csvData = compileCsvData(securities, !!includeMakerName)
    const closeToast = () => toast.dismiss('exportToast')
    const datePart = dayjs().format('MM-DD-YY HHmm')
    const gridPart = gridDataToFileNamePart(gridData)
    const fileName = `bondscom Export ${gridPart}${datePart}.csv`
    if (csvData) {
      return (
        <div className={styles.exportBtn}>
          <ExportButton
            csvData={csvData}
            onDownloadDone={closeToast}
            fileName={fileName}
          />
        </div>
      )
    }
  } else {
    if (!callState.pending) {
      return <div>No Records</div>
    }
  }

  return (
    <div>
      Export data <Loading />{' '}
    </div>
  )
}

export const getExportToastInstance = () => <ExportToastContent />

export default ExportToastContent
